var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayLaterActivate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.025 31.111H4.7V17.778h24.205a13.144 13.144 0 019.87-4.445c3.055 0 5.875 1.111 8.225 2.89V4.443c0-1.178-.495-2.309-1.377-3.142A4.84 4.84 0 0042.3 0H4.7a4.84 4.84 0 00-3.323 1.302A4.325 4.325 0 000 4.444v26.667c0 1.179.495 2.31 1.377 3.143A4.84 4.84 0 004.7 35.556h24.91c-.94-1.334-1.88-2.89-2.585-4.445zM4.7 4.444h37.6V8.89H4.7V4.444zm34.075 13.334c-4.465 0-8.225 3.555-8.225 7.778C30.55 31.333 38.775 40 38.775 40S47 31.333 47 25.556c0-4.223-3.76-7.778-8.225-7.778zm0 10.666c-1.645 0-2.82-1.333-2.82-2.666 0-1.556 1.41-2.667 2.82-2.667s2.82 1.333 2.82 2.667c.235 1.333-1.175 2.666-2.82 2.666z",
    fill: "#F8991D"
  })));
}
export default __webpack_public_path__ + "static/media/pay-later-activate.0ec09d83.svg";
export { SvgPayLaterActivate as ReactComponent };